/* GSH — replace article/ingredient/routine card + hero images with the EXACT
   image from Sanity (public read API), matched by slug (== Shopify blog handle).
   Sanity is the source of truth; this keeps every thumbnail 1:1 with the CMS,
   with no guessing/extraction. Self-guards: only runs where blog cards/heroes exist. */
(function () {
  var CARD_SEL = 'a[href*="/blogs/"]';
  var onArticle = /\/blogs\/[^\/]+\/[^\/?#]+/.test(location.pathname);
  if (!document.querySelector(CARD_SEL) && !onArticle) return;

  var PID = 'e1zi0ik2', DS = 'production';
  var BASE = 'https://' + PID + '.apicdn.sanity.io/v2021-10-21/data/query/' + DS;

  function imageUrl(img, w, h) {
    var ref = img && img.asset && img.asset._ref;
    if (!ref) return null;
    var s = ref.replace(/^image-/, '');
    var p = s.split('-');
    var fmt = p[p.length - 1];
    var dims = p[p.length - 2];
    var id = p.slice(0, p.length - 2).join('-');
    return 'https://cdn.sanity.io/images/' + PID + '/' + DS + '/' + id + '-' + dims + '.' + fmt +
      '?w=' + (w || 900) + '&h=' + (h || 700) + '&fit=max&auto=format&q=80';
  }
  function pick(d, prefCard) {
    var c = d.cardImage && d.cardImage.asset && d.cardImage.asset._ref ? d.cardImage : null;
    var h = d.heroImage && d.heroImage.asset && d.heroImage.asset._ref ? d.heroImage : null;
    return prefCard ? (c || h) : (h || c);
  }

  var Q = '{"a":*[_type=="article"&&defined(slug.current)]{"s":slug.current,heroImage{asset{_ref}},cardImage{asset{_ref}}},' +
          '"i":*[_type=="ingredient"&&defined(slug.current)]{"s":slug.current,heroImage{asset{_ref}},cardImage{asset{_ref}}},' +
          '"r":*[_type=="routine"&&defined(slug.current)]{"s":slug.current,heroImage{asset{_ref}},cardImage{asset{_ref}}}}';

  fetch(BASE + '?query=' + encodeURIComponent(Q))
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var res = j.result || {};
      var map = {};
      ['a', 'i', 'r'].forEach(function (k) {
        (res[k] || []).forEach(function (d) { if (d.s && !map[d.s]) map[d.s] = d; });
      });

      // Cards: swap the <img> inside each blog link with the Sanity card image.
      document.querySelectorAll(CARD_SEL).forEach(function (a) {
        var m = a.getAttribute('href').match(/\/blogs\/[^\/]+\/([^\/?#]+)/);
        if (!m) return;
        var d = map[m[1]]; if (!d) return;
        var img = a.querySelector('img'); if (!img) return;
        var isBig = (img.naturalWidth || img.width) > 640 || a.closest('[class*="hero"],[class*="featured"]');
        var src = imageUrl(pick(d, true), isBig ? 1000 : 600, isBig ? 700 : 400);
        if (src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; }
      });

      // Article page hero: swap with the Sanity hero image.
      if (onArticle) {
        var mm = location.pathname.match(/\/blogs\/[^\/]+\/([^\/?#]+)/);
        var d2 = mm && map[mm[1]];
        if (d2) {
          var heroImg = document.querySelector('.gsh-article__hero img');
          if (heroImg) {
            var hu = imageUrl(pick(d2, false), 1400, 900);
            if (hu) { heroImg.removeAttribute('srcset'); heroImg.removeAttribute('sizes'); heroImg.src = hu; }
          }
        }
      }
    })
    .catch(function () {});
})();
